import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React from "react";
import persianNumberFormat from "../../../helper/PersianNumberFormat";

export function ReservationGuideForm({
                                       modalOpen,
                                       setModalOpen
                                     }) {
  const handleOpen = () => setModalOpen(!modalOpen);

  return (
    <>
      <Dialog size="sm" open={modalOpen} handler={handleOpen}
              animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}
              className="max-h-screen bg-none">
        <DialogHeader className="bg-gray-800 rounded-t-2xl -mt-4">
          <Typography className="py-4 w-full text-white text-2xl z-10 textCenter">
            مراحل دریافت مشاوره
          </Typography>
        </DialogHeader>

        <DialogBody
          className="flex flex-col gap-4 rounded-2xl overflow-y-scroll max-h-[530px] md:max-h-screen">
          <div className="grid grid-col w-full px-0">
            <Typography variant="body" color="blue-gray" className="mr-8">
              <li className="list-none">
                {`${persianNumberFormat(1)}_ انتخاب موضوع مشاوره`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(2)}_ انتخاب مشاور`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(3)}_ تعیین گرایش مشاوره`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(4)}_ تعیین زمان مشاوره`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(5)}_ پرداخت`}
              </li>
              <li className="list-none">
                {`${persianNumberFormat(6)}_ دریافت مشاوره در موعد مقرر`}
              </li>
            </Typography>
          </div>

        </DialogBody>

        <DialogFooter className="space-x-2 justify-end bg-gray-800 rounded-b-2xl -mb-4">
          <Button variant="text" color="white" onClick={() => {
            handleOpen()
          }}>
            <span>بازگشت</span>
          </Button>
        </DialogFooter>
      </Dialog>
    </>
  );
}
